import { render, staticRenderFns } from "./CustomerCreateJointModal.vue?vue&type=template&id=1c9979dd"
import script from "./CustomerCreateJointModal.vue?vue&type=script&lang=js"
export * from "./CustomerCreateJointModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports